import React from "react";
import { Check } from "react-feather";

/**
 * Single option row for a poll result.
 *
 * props:
 *  - label      : option text
 *  - count      : number of votes for this option
 *  - percent    : 0-100
 *  - isCorrect  : highlights the bar green + shows a check mark
 */
const ResultBar = ({ label, count, percent, isCorrect }) => {
  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <span className={`fw-semibold ${isCorrect ? "text-success" : ""}`}>
          {label}
          {isCorrect && <Check size={16} className="ms-1 text-success" />}
        </span>

        <span className="text-muted small">
          {count} ({percent.toFixed(1)}%)
        </span>
      </div>

      <div
        className="rounded-pill"
        style={{
          height: 8,
          background: "#e9ecef",
          overflow: "hidden",
        }}
      >
        <div
          className="rounded-pill"
          style={{
            height: "100%",
            width: `${percent}%`,
            background: isCorrect ? "#2ecc71" : "#6c5ce7",
            transition: "width 0.6s ease",
          }}
        />
      </div>
    </div>
  );
};

export default ResultBar;
